// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3KSGG","right":"styles_right__3GWHm"};